import React from "react";
import { Tag } from "antd";
import theme from "styles/theme";
import useTranslation from "utils/hooks/useTranslation";
import { getSaleChannelConfig } from "utils/saleChannel";
import * as S from "./styled/index.styled";

interface ISaleChannelStatus {
  saleChannelId?: number | null;
}

const TagSaleChannel = (colorStatus: string, colorText: string, dataTestId: string, saleChannelDescription: string, borderColor: string = colorStatus) => {
  return (
    <S.TagContainer>
      <Tag className="saleChannelStatusTag" style={{ color: colorText, borderColor }} color={colorStatus} data-testid={dataTestId}>
        {saleChannelDescription}
      </Tag>
    </S.TagContainer>
  );
};

const SaleChannelStatus = ({ saleChannelId }: ISaleChannelStatus): JSX.Element => {
  const saleChannelConfig = getSaleChannelConfig(saleChannelId);
  const saleChannelDescription = useTranslation({ id: saleChannelConfig?.translationId ?? "fleet_channel_others" });

  if (!saleChannelConfig) {
    return <div />;
  }

  return (
    <div>
      {TagSaleChannel(
        saleChannelConfig.tagColor,
        saleChannelConfig.tagTextColor ?? theme.colors.defaultBackground,
        saleChannelDescription,
        saleChannelDescription,
        saleChannelConfig.tagBorderColor
      )}
    </div>
  );
};

export default SaleChannelStatus;
